import { AnimationController } from '@ionic/angular';
import type { Animation } from '@ionic/angular';

export function buildRouteSlideAnimation(animationCtrl: AnimationController) {
  return (_: HTMLElement, opts: any): Animation => {
    const backwards = opts.direction === 'back';
    const offset = backwards ? '-100px' : '100px';

    const animations: Animation[] = [];

    if (opts.enteringEl) {
      animations.push(
        animationCtrl
          .create()
          .addElement(opts.enteringEl)
          .fromTo('opacity', '0', '1')
          .fromTo('transform', `translateX(${offset})`, 'translateX(0px)')
      );
    }

    if (opts.leavingEl) {
      animations.push(
        animationCtrl
          .create()
          .addElement(opts.leavingEl)
          .fromTo('opacity', '1', '0')
          .fromTo('transform', 'translateX(0px)', `translateX(${backwards ? '100px' : '-100px'})`)
      );
    }

    return animationCtrl
      .create()
      .easing('cubic-bezier(0.175, 0.185, 0.32, 1.08)')
      .duration(150)
      .addAnimation(animations);
  };
}
